import { Link } from 'react-router-dom';

export function BrandMark({ className = 'h-10 w-10', inverse = false }) {
  const navy = inverse ? '#FFFFFF' : '#07183F';
  const indigo = inverse ? '#9EA9FF' : '#4654D8';
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label="ConcorsiEssentials">
      <path d="M36.5 8.5A23.5 23.5 0 1 0 38 54" fill="none" stroke={navy} strokeWidth="9" strokeLinecap="round" />
      <path d="M27 23h23a5 5 0 0 0 0 10H27a5 5 0 0 1 0-10Zm0 10h23a5 5 0 0 0 0 10H27a5 5 0 0 1 0-10Z" fill="none" stroke={indigo} strokeWidth="4" strokeLinejoin="round" />
      <path d="M34 41h11v17l-5.5-4-5.5 4V41Z" fill={indigo} />
      <path d="M49 43h7v6h-7" fill="none" stroke={indigo} strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}

export function BrandLogo({ compact = false, payoff = false, inverse = false, className = '' }) {
  const text = inverse ? 'text-white' : 'text-[#07183F]';
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <BrandMark className={compact ? 'h-9 w-9' : 'h-11 w-11'} inverse={inverse} />
      {!compact && (
        <span className="min-w-0">
          <span className={`block font-display font-bold leading-none tracking-[-0.035em] ${text}`}>
            Concorsi<span className={inverse ? 'text-indigo-300' : 'text-[#4654D8]'}>Essentials</span>
          </span>
          {payoff && <span className={`mt-1.5 block text-[0.56rem] font-semibold uppercase tracking-[0.28em] ${inverse ? 'text-slate-300' : 'text-[#07183F]'}`}>Studia solo ciò che conta.</span>}
        </span>
      )}
    </span>
  );
}

export function BrandLink(props) {
  return <Link to="/" aria-label="ConcorsiEssentials — Home" {...props}><BrandLogo /></Link>;
}
